import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Refund = () => {
  return (
    <>
      <Container>
      <div className="container mt-5">
        <h2 className="mb-4 mt-5 text-center">Terms and Conditions</h2>

        <div className="mt-5">
          
            <h3 className="text-black">1. Introduction
            </h3>
            <p>These Terms and Conditions govern the provision of architectural services by BDA to its clients. By engaging our services, the Client agrees to these terms.</p>
            <br/>

            <h3 className="text-black">2. Scope of Services</h3>
            <p>BDA will provide architectural services as outlined in the project proposal. Services may include design, planning, project management, and consultation, subject to the Client's specific requirements.</p>
            <br/>

            <h3 className="text-black">3. Fees and Payment
            </h3>
            <li className="mt-2">The Client agrees to pay fees as detailed in the project proposal.</li>
            <li className="mt-2">Payment terms including deposits, milestones, and final payment will be specified in the proposal.</li>
            <li className="mt-2">Late payments may incur interest charges as specified in the agreement.</li>
            <br/>

            <h3 className="text-black">4. Project Timeline</h3>
            <p>The Company will provide an estimated timeline for project completion. The timeline may be adjusted due to unforeseen circumstances, changes in scope, or delays caused by the Client.</p>
            <br/>

            <h3 className="text-black">5. Client Responsibilities
            </h3>
            <p className="mt-2">The Client agrees to :</p>
            <li className="mt-2">Provide all necessary information and access required for the project.</li>
            <li className="mt-2">Make timely decisions and approvals to facilitate progress.</li>
            <li className="mt-2">Pay all fees as outlined.</li>
            <br/>

            <h3 className="text-black">6. Changes to Scope</h3>
            <p>Any changes to the project scope must be communicated in writing and may result in additional fees and alterations to the timeline.</p>
            <br/>

            <h3 className="text-black">7. Ownership of Documents</h3>
            <p>Upon full payment, the Client will own the final architectural drawings and documents. Unless otherwise agreed the Company retains the right to use design work for promotional purposes.</p>
            <br/>

            <h3 className="text-black">8. Confidentiality</h3>
            <p>Both parties agree to keep all project-related information confidential unless disclosure is required by law or mutually agreed upon in writing.</p>
            <br/>

            <h3 className="text-black">9. Limitation of Liability</h3>
            <p>BDA shall not be liable for indirect, incidental, or consequential damages from the services provided. Liability is limited to the amount paid for the services.</p>
            <br/>

            <h3 className="text-black">10. Governing Law</h3>
            <p>These Terms and Conditions are governed by the laws of India. Any disputes will be resolved in the appropriate courts of that jurisdiction.</p>
            <br/>

            <h3 className="text-black">11. Amendments</h3>
            <p>These terms may be amended only in writing and signed by both parties.</p>
            <br/>

            <h3 className="text-black">12. Acceptance</h3>
            <p>By engaging BDA, the Client acknowledges that they have read, understood, and accepted these Terms and Conditions.</p>          
            <br/>
        </div>
      </div>
      </Container>
    </>
  );
};

export default Refund;
const Container = styled.div`
  p {
    /* color: #7d858c; */
    color: "#000000";
    font-size: 18px;
    font-family: "Lato";
  }
  span {
    color: chocolate;
    font-size: 1.1rem;
    font-weight: 700;
  }
  .colors {
    color: "#E99FOE";
  }
  .margin {
    margin-left: 5px;
  }
`;
